import { ChangeDetectionStrategy, Component } from "@angular/core";
import { EducationType } from "@ha/data/basic";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";

import { CurrentUserState } from "../../../core/states/current-user.state";
import { Home } from "../../models/home.model";
import { HomeSelectors } from "../../state/home.selectors";

@UntilDestroy()
@Component({
    selector: "home-notifications",
    templateUrl: "./home-notifications.component.html",
    styleUrls: ["home-notifications.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeNotificationsComponent {
    @Select(HomeSelectors.data)
    public data$: Observable<Home>;

    @Select(CurrentUserState.firstName)
    public firstName$: Observable<string>;

    @Select(CurrentUserState.isCertificateExpiring)
    public isCertificateExpiring$: Observable<boolean>;

    @Select(CurrentUserState.isExternal)
    public isExternal$: Observable<boolean>;

    public educationType = EducationType;

    public getEducationEventUrl(currentEducationEventId: number): string[] {
        return [...this.getEducationListUrl(), currentEducationEventId.toString()];
    }

    public getEducationListUrl(): string[] {
        return ["/", "education"];
    }
}
